import "./styles.scss";

const Overlay = ({ show = false, absolute = true, styling = {} }) => {
  return show ? <div className="overlay" style={{ position: "absolute", ...styling }}></div> : null;
};

export default Overlay;
